import * as React from 'react';
export const chevronLeftCircleSvg = React.forwardRef(
  function chevronLeftCircleSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M9.78 12.28a.75.75 0 0 0 0-1.06L6.56 8l3.22-3.22a.75.75 0 0 0-1.06-1.06L4.97 7.47a.75.75 0 0 0 0 1.06l3.75 3.75a.75.75 0 0 0 1.06 0Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M1.5 8A6.5 6.5 0 0 1 8 1.5c3.592 0 6.5 2.9 6.5 6.5A6.5 6.5 0 0 1 8 14.5 6.5 6.5 0 0 1 1.5 8ZM0 8a8 8 0 0 1 8-8c4.419 0 8 3.57 8 8a8 8 0 0 1-8 8 8 8 0 0 1-8-8Z',
      }),
    );
  },
);
chevronLeftCircleSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var chevronLeftCircle = {
  category: 'icon',
  colorable: true,
  name: 'chevronLeftCircle',
  svg: chevronLeftCircleSvg,
};
